// Build-time loader for the widget SRI manifest. Mirrors
// apps/docs/src/lib/widget-integrity.ts so docs + dashboard see the same
// hash. Turbo's task graph guarantees @cortex/widget builds before the
// dashboard — `dist/integrity.json` exists at Vite-build time.
//
// We use `import.meta.glob` (eager) rather than a bare `import` so the
// bundle still compiles when the file is missing in a cold `dashboard dev`
// session. In that case we surface a placeholder hash + a banner in the
// UI so the contributor knows to run `pnpm --filter @cortex/widget build`.

interface IntegrityEntry {
  file: string;
  sha384: string;
  sha384Header: string;
  bytes: number;
  gzipBytes: number;
}

interface IntegrityManifest {
  widget: IntegrityEntry;
  index: IntegrityEntry;
}

const PLACEHOLDER_HASH = 'sha384-PLACEHOLDER_HASH_RUN_PNPM_BUILD_FIRST';

// Glob returns {} when the file doesn't exist — matches how the docs loader
// survives a fresh checkout. When present, Vite inlines the JSON statically
// so no network/fs round-trip happens at runtime.
const manifestGlob = import.meta.glob<IntegrityManifest>(
  '../../../../packages/widget/dist/integrity.json',
  { eager: true, import: 'default' },
);
const manifest: IntegrityManifest | undefined = Object.values(manifestGlob)[0];

// Version-pinned per the Cloudflare Worker allowlist. Bumping the major
// means cutting a new immutable URL on the CDN — kept identical to
// apps/docs/src/lib/widget-integrity.ts by convention.
export const WIDGET_VERSION = 'v1';
export const WIDGET_CDN_BASE = 'https://cdn.cortexlayer.dev';
export const WIDGET_URL = `${WIDGET_CDN_BASE}/widget.${WIDGET_VERSION}.js`;
export const WIDGET_SRI = manifest?.widget.sha384Header ?? PLACEHOLDER_HASH;
export const WIDGET_BYTES_GZIP = manifest?.widget.gzipBytes ?? 0;
export const WIDGET_SRI_LIVE = manifest !== undefined;
